<div class="search-result-view-thumbnail h-full">
  <ul class="thumbContainer h-full">
    <cdk-virtual-scroll-viewport
      itemSize="256"
      class="scroll-viewport-height"
      [style.width]="width"
      [ngClass]="{'folder': searchContainer.currentPathView.search_view.search_view_type === 'folder',
                  'open': searchContainer.isFolderInfoOpen}"
    >
      <ng-container
        *cdkVirtualFor="let searchObjectRow of ds"
        class="scroll-item"
      >
        @if (searchObjectRow) {
          <ng-container>
            @for (art of searchObjectRow.columns; track $index) {
              <li
                class="searchResultItem searchResultPanel"
                [ngClass]="{'selected': searchContainer.selections.selected[art.artifact_id]}"
              >
                @if (art) {
                  <div>
                    <div
                      class="searchResultPanel--img-container"
                      [ngClass]="{'folder': art.object_type === 'folder'}"
                    >
                      <div class="checkbox-underlay">
                        <span
                          class="checkbox-tooltip-wrapper"
                          [class.cursor-not-allowed]="isCheckboxDisabled(art) && !art.$$used"
                          [matTooltip]="isCheckboxDisabled(art) && !art.$$used ? ('TRANS__SEARCH_SELECTIONS__TOO_MANY_SELECTED' | translate) : ''"
                        >
                          <label class="custom-checkbox-container">
                            <input
                              type="checkbox"
                              (click)="select(art, $event)"
                              (keydown)="null"
                              [checked]="isCheckboxSelected(art)"
                              [disabled]="isCheckboxDisabled(art)"
                            >

                            <span class="ripple"></span>

                            <span class="checkmark"></span>
                          </label>
                        </span>
                      </div>

                      @if (art.has_authority) {
                        <div class="authority-ribbon-container">
                          <div
                            class="authority-ribbon"
                            [ngClass]="{'situla': art.authority_id === clientConfig.AUTHORITY_ARCHAEOLOGY_ID,
                                        'ribbon-kultur-nav': art.authority_id === clientConfig.AUTHORITY_KULTURNAV_ID}"
                          >
                            {{art.authority_id_value}}
                          </div>
                        </div>
                      }


                      <a
                        [routerLink]="getRouterLink(art)"
                        [queryParams]="art.$$refData?.queryParams"
                        queryParamsHandling="merge"
                        (click)="setSearchItemIndex(art.$$refData.param['searchItemIndex'])"
                        class="search-result-view-thumbnail__thumbnail-url"
                      >
                        @if (art.$$imageUrl) {
                          <img
                            alt="{{art.artifact_name}}"
                            [src]="art.$$imageUrl"
                          >
                        }
                        @else {
                          <i
                            class="{{art.$$noImageIcon}} imgIcon"
                            [ngClass]="{'text-blue': art.object_type === 'folder'}"
                          ></i>
                        }
                      </a>
                    </div>

                    <div class="searchResultPanel--thumbInfo-container">
                      <div class="search-result-view-thumbnail__headline">
                        <i
                          class="searchIcon object-icon {{art.$$icon}}"
                          [class.text-blue]="art.meta_type === MetaTypes.ADM_EVENT"
                        ></i>

                        <a
                          [routerLink]="getRouterLink(art)"
                          [queryParams]="art.$$refData?.queryParams"
                          queryParamsHandling="merge"
                          (click)="setSearchItemIndex(art.$$refData.param['searchItemIndex'])"
                          class="search-result-view-thumbnail__headline-url"
                        >
                          <span
                            class="object-url-content"
                            [innerHTML]="art.$$name"
                          ></span>
                        </a>
                      </div>

                      <app-search-tile-overview-fields
                        [searchObject]="art"
                        [viewName]="searchContainer.searchResultViewName"
                      ></app-search-tile-overview-fields>
                    </div>
                  </div>
                }
              </li>
            }

            @if (columns > searchObjectRow.columns.length) {
              <li
                [ngStyle]="{'width': (202 * (columns - searchObjectRow.columns.length)) + 'px'}"
                class="search-result-view-thumbnail__empty-column"
              ></li>
            }
          </ng-container>
        }
      </ng-container>
    </cdk-virtual-scroll-viewport>
  </ul>
</div>
